import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, throwError } from 'rxjs';
import { AuthService } from '../auth-service/auth-service.service';
import { environment } from '../../../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PostService {

  public loading = new BehaviorSubject<boolean>(false);

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService) { }

  submit(file: File): Observable<any> {
    this.loading.next(true);
    const formData: FormData = new FormData();
    formData.append('file', file);

    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.getAccessToken(),
      'AuthSession': this.authService.getSessionToken()
    });

    return this.httpClient.post(environment.apiUrl + '/api/post/submit', formData, {
      headers: headers,
      responseType: 'json'
    }).pipe(
      map((resp: any) => {
        this.loading.next(false);
        return resp;
      }),
      catchError((error) => {
        this.loading.next(false);
        return throwError(() => error); //return ""; //tbc empty value?
      })
    );
  }

  validate(file: File): Observable<any> {
    this.loading.next(true);
    const formData: FormData = new FormData();
    formData.append('file', file);

    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.getAccessToken(),
      'AuthSession': this.authService.getSessionToken()
    });

    return this.httpClient.post(environment.apiUrl + '/api/post/validate', formData, {
      headers: headers,
      responseType: 'json'
    }).pipe(
      map((resp: any) => {
        this.loading.next(false);
        return resp;
      }),
      catchError((error) => {
        this.loading.next(false);
        return throwError(() => error); //return ""; //tbc empty value?
      })
    );
  }
}